var map = {
	"./Android.png": 127,
	"./Firebase.png": 128,
	"./Flutter.png": 129,
	"./HybridNative.png": 130,
	"./Industries/Hospitality.svg": 318,
	"./Industries/Jobs.svg": 319,
	"./Industries/Law.svg": 320,
	"./Industries/Manufacturing.svg": 321,
	"./Industries/RealEstate.svg": 322,
	"./Industries/Retail.svg": 323,
	"./Industries/Technology.svg": 324,
	"./Industries/eCommerce.svg": 325,
	"./Industries2/Blockchain.png": 326,
	"./Industries2/Health&Sustainability.png": 327,
	"./Industries2/Manufacturing.png": 328,
	"./Industries2/eCommerce.png": 329,
	"./Industries2/retail.png": 330,
	"./MP4-Video.mp4": 331,
	"./Mtech/inventoryManagementsystem.jpg": 332,
	"./Mtech/socialmediaMarketing.jpg": 333,
	"./Mtechold/inventoryManagementsystem.png": 334,
	"./Mtechold/socialmediaMarketing.jpg": 335,
	"./MunafaMart/Graphicdesign.jpg": 336,
	"./MunafaMart/Mobleapp.jpg": 337,
	"./MunafaMart/SocialMediaMarketing.jpg": 338,
	"./MunafaMart/Website.jpg": 339,
	"./NativeScript.png": 131,
	"./Platformsicons/Algolia.png": 132,
	"./Platformsicons/Digital_Ocean.png": 133,
	"./Platformsicons/Drupal.png": 134,
	"./Platformsicons/GCP.png": 135,
	"./Platformsicons/Joomla.png": 136,
	"./Platformsicons/Magento.png": 137,
	"./Platformsicons/Opencart.png": 138,
	"./Platformsicons/Prestashop.png": 139,
	"./Platformsicons/Shopify.png": 140,
	"./Platformsicons/Technologies.png": 141,
	"./Platformsicons/Woocommerce.png": 142,
	"./Platformsicons/aws.png.png": 143,
	"./Platformsicons/django.png": 144,
	"./Platformsicons/osCommerce.png": 145,
	"./Platformsicons/wordpress.png": 91,
	"./ReactNative3.png": 146,
	"./Serviceicon/Group23.png": 340,
	"./Serviceicon/Group24.png": 341,
	"./Serviceicon/Group25.png": 342,
	"./Serviceicon/Group26.png": 343,
	"./Serviceicon/Group27.png": 344,
	"./Serviceicon/Group28.png": 345,
	"./Serviceicon/Group29.png": 346,
	"./Serviceicon/Group30.png": 347,
	"./Serviceicon/Group31.png": 348,
	"./Serviceicon/Group32.png": 349,
	"./Serviceicon/Group33.png": 350,
	"./Serviceicon/Group34.png": 351,
	"./Serviceicon/Group35.png": 352,
	"./Serviceicon/Group36.png": 353,
	"./Serviceicon/Group37.png": 354,
	"./Serviceicon/Group38.png": 355,
	"./Serviceicon/Group39.png": 356,
	"./Serviceicon/build-and-crawl.png": 357,
	"./Serviceicon/deliver-data.png": 358,
	"./Serviceicon/requirements.png": 359,
	"./Teafloor/1.jpg": 360,
	"./Teafloor/2.jpg": 361,
	"./Teafloor/3.jpg": 362,
	"./Teafloor/4.jpg": 363,
	"./Teafloor/Branding.jpg": 364,
	"./Teafloor/Photography.jpg": 365,
	"./Teafloor/old website.png": 366,
	"./Teafloor/socialMediaMarketing.jpg": 367,
	"./Teafloor/website.jpg": 368,
	"./Technologies2.png": 147,
	"./TrulyMadly/SocialMediaMarketing.jpg": 369,
	"./TrulyMadly/mobileWeb.jpg": 370,
	"./VikasSpools/websiteDesign.jpg": 371,
	"./Wickey/Dataanalytics.jpg": 372,
	"./Wickey/odlwebCrawling.jpg": 373,
	"./Wickey/webCrawling.jpg": 374,
	"./about_us.jpg": 92,
	"./accounting.svg": 375,
	"./add_project.svg": 148,
	"./add_stock.svg": 149,
	"./advanced_reporting.svg": 150,
	"./advanced_user_management.svg": 151,
	"./appdevelopment.jpg": 152,
	"./appdevelopment.png": 153,
	"./assign_task.svg": 154,
	"./audit.svg": 155,
	"./basic_plan.svg": 156,
	"./books_demo.png": 93,
	"./books_logo.svg": 157,
	"./brand.svg": 21,
	"./career.jpg": 158,
	"./career.png": 376,
	"./ceo.jpg": 377,
	"./client-background.png": 46,
	"./client-header.jpg": 159,
	"./client_logo/baked-pizza.jpg": 26,
	"./client_logo/beccos.jpg": 13,
	"./client_logo/bng.png": 27,
	"./client_logo/bonobology.jpg": 28,
	"./client_logo/canon.png": 47,
	"./client_logo/creatanium.png": 29,
	"./client_logo/dubaipetroleum.png": 48,
	"./client_logo/erosgroup.png": 49,
	"./client_logo/fractal.png": 50,
	"./client_logo/garage-cafe.jpg": 378,
	"./client_logo/garagecafe.png": 51,
	"./client_logo/ges.png": 52,
	"./client_logo/golds.png": 53,
	"./client_logo/governmentsarjah.png": 54,
	"./client_logo/greenchoice.png": 18,
	"./client_logo/home_registry.jpg": 94,
	"./client_logo/huawei.png": 55,
	"./client_logo/leverage_group.jpg": 95,
	"./client_logo/m-tech.jpg": 30,
	"./client_logo/munafamart.jpg": 379,
	"./client_logo/munafamart.png": 8,
	"./client_logo/phone.png": 56,
	"./client_logo/pico.png": 57,
	"./client_logo/resplendentcosmetics.png": 58,
	"./client_logo/saudiaramco.png": 59,
	"./client_logo/scale_labs.jpg": 31,
	"./client_logo/tanoshii-trails.jpg": 160,
	"./client_logo/tanoshiitrail.png": 32,
	"./client_logo/teafloor.png": 14,
	"./client_logo/techrobotix.jpg": 161,
	"./client_logo/techrobotix.png": 60,
	"./client_logo/truly_madly.jpg": 33,
	"./client_logo/vikas_spools.jpg": 22,
	"./client_logo/wickey.jpg": 34,
	"./complete_control.svg": 380,
	"./custom_solutions.svg": 162,
	"./data_mining.svg": 381,
	"./datamining.jpg": 382,
	"./datamining.png": 163,
	"./deploy_code.svg": 164,
	"./digital_marketing.svg": 383,
	"./digitalmarketing.jpg": 165,
	"./digitalmarketing.png": 166,
	"./download.svg": 167,
	"./download_data.svg": 384,
	"./easy_upload.svg": 385,
	"./experientialmarketing.jpg": 386,
	"./experientialmarketing.mp4": 168,
	"./experientialmarketing.png": 169,
	"./extact-lappy.jpg": 96,
	"./extract_demo.png": 97,
	"./extract_logo.svg": 170,
	"./float_schemes.svg": 387,
	"./float_schemes_directly.svg": 171,
	"./get_started.svg": 172,
	"./give_schemes.svg": 173,
	"./hari.jpg": 174,
	"./high_scalability.svg": 388,
	"./ic_compass.svg": 389,
	"./ic_quote_left.svg": 125,
	"./icon-distribution.svg": 390,
	"./icon-lead.svg": 391,
	"./icon-market.svg": 392,
	"./icon-pricing.svg": 393,
	"./inventory_management-1.svg": 394,
	"./inventory_management.svg": 395,
	"./ios.png": 175,
	"./laptop.jpg": 126,
	"./laptopwithmobile.png": 90,
	"./lead_generation.svg": 396,
	"./logging.svg": 397,
	"./logo.png": 398,
	"./manage_product_ inventory.svg": 176,
	"./map.png": 12,
	"./marketing-demo.jpg": 399,
	"./mentor_business.jpg": 400,
	"./mentor_business.png": 401,
	"./mentor_marketing.jpg": 402,
	"./mentor_marketing.png": 403,
	"./mobile.svg": 177,
	"./monitor_inventory.svg": 404,
	"./monitor_tasks.svg": 178,
	"./motion.svg": 179,
	"./mukul.jpg": 180,
	"./multi_location.svg": 405,
	"./multiple_crawlers.svg": 406,
	"./notify_channel.svg": 407,
	"./offline_capabilities.svg": 408,
	"./oldMunafaMart/Graphicdesign.jpg": 409,
	"./oldMunafaMart/Mobleapp.jpg": 410,
	"./oldMunafaMart/SocialMediaMarketing.jpg": 411,
	"./oldMunafaMart/Website.png": 412,
	"./payroll.svg": 413,
	"./perks.jpg": 181,
	"./personalisation.svg": 182,
	"./premiumplan.svg": 61,
	"./productIdeation.png": 183,
	"./publish_important.svg": 414,
	"./purchase_item.svg": 184,
	"./real-time_inventroy.svg": 185,
	"./rectangle1.png": 62,
	"./rectangle2.png": 63,
	"./scan.svg": 186,
	"./scheduler.svg": 415,
	"./sell_return.svg": 416,
	"./seo/analytics-seo.jpg": 187,
	"./seo/callico.png": 188,
	"./seo/envelope.png": 189,
	"./seo/icon.png": 190,
	"./seo/seo.jpg": 417,
	"./serviceicon2/advanced-web-scraping.svg": 418,
	"./serviceicon2/data-cleanliness.svg": 419,
	"./serviceicon2/group40.png": 420,
	"./serviceicon2/group41.png": 421,
	"./serviceicon2/group42.png": 422,
	"./serviceicon2/group43.png": 423,
	"./serviceicon2/group44.png": 424,
	"./serviceicon2/group45.png": 425,
	"./serviceicon2/group46.png": 426,
	"./serviceicon2/group47.png": 427,
	"./serviceicon2/group48.png": 428,
	"./serviceicon2/group49.png": 429,
	"./serviceicon2/group50.png": 430,
	"./serviceicon2/group51.png": 431,
	"./serviceicon2/group52.png": 432,
	"./serviceicon2/handles-anti-scraping.svg": 433,
	"./serviceicon2/highly-customizable.svg": 434,
	"./serviceicon2/highly-scalable.svg": 435,
	"./serviceicon2/iconDistribution.svg": 436,
	"./serviceicon2/iconLead.svg": 437,
	"./serviceicon2/iconMarket.svg": 438,
	"./serviceicon2/iconPricing.svg": 439,
	"./serviceicon2/preferred-format.svg": 440,
	"./serviceicons3/group57.png": 441,
	"./serviceicons3/group58.png": 442,
	"./serviceicons3/group59.png": 443,
	"./serviceicons3/group60.png": 444,
	"./serviceicons3/group61.png": 445,
	"./serviceicons3/group62.png": 446,
	"./serviceicons3/group63.png": 447,
	"./serviceicons3/group64.png": 448,
	"./serviceicons3/group65.png": 449,
	"./single_channel_partner.svg": 450,
	"./teafloor-portfolio-1.jpg": 451,
	"./teafloor1.jpg": 452,
	"./teafloor2.jpg": 453,
	"./teafloor3.jpg": 454,
	"./teafloor4.jpg": 455,
	"./teafloor5.jpg": 456,
	"./team.jpg": 191,
	"./transfer_stock.svg": 192,
	"./trckr_demo.png": 98,
	"./trial_plan.svg": 193,
	"./typepo.svg": 194,
	"./ui.svg": 195,
	"./uiux.jpg": 196,
	"./user-image-1.png": 457,
	"./user-image-2.png": 458,
	"./user-image-3.png": 459,
	"./user_experience.svg": 460,
	"./utilitiesicons/company.png": 197,
	"./utilitiesicons/exhibitions.png": 198,
	"./utilitiesicons/launches.png": 199,
	"./utilitiesicons/outdoor.png": 200,
	"./utilitiesicons/permanent.png": 201,
	"./ux.svg": 202,
	"./uxui.png": 203,
	"./video-screenhost.jpg": 99,
	"./web-crawling_site.png": 204,
	"./webdesign.png": 205,
	"./webdevelopment.jpg": 206,
	"./webdevelopment.png": 207,
	"./webdevelopment2.png": 208,
	"./webhosting.png": 209,
	"./webmaintenance.png": 210,
	"./work1.png": 3,
	"./work2.png": 45,
	"./work3.png": 84,
	"./work4.png": 85,
	"./work5.png": 86,
	"./work6.png": 87,
	"./work7.png": 88,
	"./work8.png": 89
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 317;


//////////////////
// WEBPACK FOOTER
// ./src/static ^\.\/.*$
// module id = 317
// module chunks = 0